export { useToastFooter_unstable as useToastFooter } from '@fluentui/react-toast';
